export default __webpack_public_path__ + "static/media/python.59cb6424.png";